import React from 'react';
import {
   Image,
   Text,
   TouchableOpacity,
   View,
   StyleSheet,
   Dimensions,
} from 'react-native';
import {
   moduleCountBGColor,
   drawerListBackgroundColor,
   courseListBGColor,
   lockedCourseBGColor,
   courseSerialNumberColor,
   FONT_FAMILY_REGULAR,
} from '../../utils/utils';

const {width, height} = Dimensions.get('window');

const ModuleDetailItem = ({
   icon,
   title,
   iconTintColor,
   titleColor,
   isSelected,
   index,
   locked,
}) => (
   <View style={{marginHorizontal: 16}}>
      {/** Unlocked courses and locked courses have different parent views */}

      <View style={styles.item}>
         <View
            style={{
               flexDirection: 'row',
               justifyContent: 'center',
               alignItems: 'center',
            }}>
            <View
               style={{
                  backgroundColor: '#000000',
                  borderRadius: 4,
                  height: 32,
                  width: 32,
                  alignContent: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
               }}>
               <Text style={[styles.serialTitle, {color: titleColor}]}>
                  {parseInt(index) + 1}
               </Text>
            </View>

            <Text style={[styles.title]}>{title}</Text>
         </View>

         <View
            style={{
               flexDirection: 'row',
               justifyContent: 'center',
               alignItems: 'center',
            }}>
            <View
               style={{
                  backgroundColor: moduleCountBGColor,
                  borderRadius: 32,
                  height: 32,
                  width: 64,
                  alignContent: 'center',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  flexDirection: 'row',
                  marginHorizontal: 10,
               }}>
               <Image
                  style={{marginLeft: 10}}
                  source={require('../../assets/modulesCountIcon.png')}
               />
               <Text style={[styles.moduleCountTitle]}>{'6'}</Text>
            </View>

            <View
               style={{
                  backgroundColor: index < 1 ? '#26E555' : '#808080',
                  borderRadius: 4,
                  height: 32,
                  width: 32,
                  alignContent: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: 5,
               }}>
               <Image source={require('../../assets/single_tick.png')} />
            </View>
         </View>
      </View>
   </View>
);

const styles = StyleSheet.create({
   item: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginHorizontal: 0,
      height: 40,
      backgroundColor: drawerListBackgroundColor,
      borderRadius: 4,
   },
   lockedItem: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginHorizontal: 0,
      height: 40,
      backgroundColor: lockedCourseBGColor,
      borderTopLeftRadius: 20,
      borderBottomLeftRadius: 20,
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
   },
   title: {
      fontSize: 14,
      fontFamily: FONT_FAMILY_REGULAR,
      marginLeft: 10,
      color: 'white',
      fontWeight: '700',
   },
   serialTitle: {
      fontSize: 20,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      textAlign: 'center',
   },
   moduleCountTitle: {
      fontSize: 14,
      fontFamily: FONT_FAMILY_REGULAR,
      marginLeft: 10,
      color: 'white',
      fontWeight: '700',
      marginRight: 10,
   },
});

export default ModuleDetailItem;
